



















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    errorPreamble: String,
    errors: Array
  }
})
